module.exports = __webpack_public_path__ + "static/media/IMG-8.93df3e12.jpg";